import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularFireAuth } from "angularfire2/auth";
import { BackendService } from "../../shared/services/backend.service";
import { LoaderService } from "../../shared/services/loader.service";
import { AccountService } from "./../../shared/account/account.service";
import { AuthService } from "./../../shared/services/auth.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  title = "app";

  user = {
    email: "",
    password: ""
  };
  failedLoggedInMessage: string;
  passwordType = "password";
  private authInstance: AngularFireAuth;

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService
  ) {
    this.failedLoggedInMessage = "";
    this.authInstance = this.authService.getAngularFireAuthInstance();
  }

  ngOnInit(): void {
    const roleState = this.route.snapshot.paramMap.get("deactivated");
    if (roleState) {
      this.failedLoggedInMessage = "You have been logged out, contact administrator for support";
    }
  }

  togglePassword(): void {
    this.passwordType = this.passwordType === "password" ? "text" : "password";
  }

  validateEmail(event: any): void { }

  /**
   * @description allow authenticated user to access app resources
   * @param email valid user email address
   * @param password valid user password
   * @returns Promise <void>
   */
  signIn(): void {
    this.loaderService.startLoader();
    this.user.email = this.user.email.toLowerCase();
    const userId = BackendService.generateUserId(this.user.email);

    this.authInstance.auth.signInWithEmailAndPassword(this.user.email, this.user.password)
      .catch(err => {
        console.log("Login error ", err);
        this.failedLoggedInMessage = "Cannot log in, check your email and/or password.";
        this.authInstance.auth.signOut();
      }).then(result => {
        if (result) {
          this.accountService.getProfile(userId).subscribe((profile: any) => {
            if (profile) {
              const canProceed = this.accountService.canAccessAppResources(profile.roles);
              if (canProceed) {
                this.accountService.setUserId(userId);
                localStorage.setItem(`${userId}-loopmi-key`, this.user.email);
                localStorage.setItem(`${userId}-loopmi-secret`, this.user.password);
                this.router.navigate(["dashboard/r/0"]);
              } else {
                this.authInstance.auth.signOut();

                this.failedLoggedInMessage =
                  !profile.isAdmin && profile.wasAdmin ? "Cannot log in, kindly contact Super Admin for support." :
                    "Cannot log in, kindly contact administrator for support.";
                this.loaderService.stopLoader();
              }
            } else {
              this.failedLoggedInMessage = "Oops! Your profile no longer exist, please contact Admin for support.";
              this.loaderService.stopLoader();
            }
          });
        } else {
          this.loaderService.stopLoader();
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts